import './menu/js/module';
import sticky from './sticky/js/module';
import header from './header/js/module';
import initializeSvg from './icon/js/module';
import initializeGrowler from './growler/js/module';
import initializeAlpineJS from './alpinejs/js/module';
import { addFormFieldDisabledValidation, addValidationErrorInputStyles, hideFormValidationSummary } from './form/js/module';
import addressFinderStore from './address-finder/js/module';
import {
  Dropdown,
  initializeDropdown,
  toggleDropdownDisable,
  toggleDropdownValidationError,
} from './dropdown/js/module';
import { ChipsDropdown, initializeChipsDropdown, unSelectChip } from './chips-dropdown/js/module';
import { CardSelector, initializeCardSelector } from './card-selector/js/module';
import { formatCardNumber, initializeHopCardSelector } from './hop-card-selector/js/module';
import {
  storeEntry,
  storeUnauthenticated,
  storeAuthenticatedWithCard,
  storeAuthenticatedWithoutCard,
  storeAuthenticatedPreregistrationDisabled,
  CCCGoogleAnalytics4,
} from './ccc-core/js/module';
import initializeCheckboxCards from './checkbox-card/js/module';
import './page-index/js/module';
import './skip-navigation/js/module';
import initializeAccordion from './accordion-component/js/module';
import initializeZoomableImage from './image/js/module';
import { initializeTabs, Tabs } from './tabs/js/module';
import createSearchBox from './search-box/js/module';
import createFilter from './filter/js/module';
import initializeParkingWidget from './parkingwidget/js/module';
import pushGTMEvent from './gtm/js/module';
import {
  corporateEHSConcessionStore,
} from './concession-core/js/module';
import { toggleMobileSidebarMenuLevel2 } from './sidebar-menu/js/module';
import { initializeDatepicker } from './datepicker/js/module';
import textInputs from './text-inputs/js/module';
import { LettersButtons, initializeLettersButtons } from './letters-buttons/js/module';
import { Timetable, initializeTimetable } from './timetable/js/module';
import { Carousel, initializeCarousel } from './carousel/js/module';
import initAccountDetailsForm from './account-details/js/module';
import { initializeFeedbackAccordion } from './feedback-banner/js/module';
import initAccordion from './universal-accordion/js/module';
import { showChip, hideChip, initializeInputChips } from './chips/js/module';
import { DynamicTable, initializeDynamicTable } from './dynamic-table/js/module';

window.pushGTMEvent = pushGTMEvent;

export default {
  sticky,
  header,
  initializeSvg,
  initializeGrowler,
  initializeAlpineJS,
  initializeParkingWidget,
  addFormFieldDisabledValidation,
  addressFinderStore,
  Dropdown,
  initializeDropdown,
  toggleDropdownDisable,
  toggleDropdownValidationError,
  ChipsDropdown,
  initializeChipsDropdown,
  unSelectChip,
  CardSelector,
  initializeCardSelector,
  formatCardNumber,
  initializeHopCardSelector,
  storeEntry,
  storeUnauthenticated,
  storeAuthenticatedWithCard,
  storeAuthenticatedWithoutCard,
  storeAuthenticatedPreregistrationDisabled,
  initializeCheckboxCards,
  CCCGoogleAnalytics4,
  initializeAccordion,
  initializeZoomableImage,
  Tabs,
  initializeTabs,
  createSearchBox,
  createFilter,
  corporateEHSConcessionStore,
  addValidationErrorInputStyles,
  hideFormValidationSummary,
  toggleMobileSidebarMenuLevel2,
  initializeDatepicker,
  textInputs,
  LettersButtons,
  initializeLettersButtons,
  Timetable,
  initializeTimetable,
  Carousel,
  initializeCarousel,
  pushGTMEvent,
  initAccountDetailsForm,
  initializeFeedbackAccordion,
  initAccordion,
  showChip,
  hideChip,
  initializeInputChips,
  DynamicTable,
  initializeDynamicTable,
};
